
import React, { useState, useRef,useEffect,useMemo} from 'react';
import styled from 'styled-components';
import { getHostName } from '../../utils/urlUtils';
import { CenteredContainer, LoadingIndicator } from '../dataloading';
import { useTranslation } from 'react-i18next';
import { requestUrl } from '../../requestUrl';
import { processMathString } from '../../utils/commonUtils';
import { useSnackbar } from '../../SnackbarProvider';
import CustomButton from '../../components/CustomButton';
import { Tabs, Tab, Box, Button } from "@mui/material";
import { Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Paper, Pagination,Modal,Checkbox ,TextField,IconButton } from '@mui/material';
import DeleteIcon from '@mui/icons-material/Delete';
import { getColorDark,getColorLight,getTheme } from '../../ColorManager';
import { ResizableBox } from "react-resizable";
import "react-resizable/css/styles.css";
import LoadingData from '../dataloading';
import { List, ListItem, ListItemText } from '@mui/material';
import { Dialog, DialogActions, DialogContent, DialogTitle } from '@mui/material';
import { MenuItem, Select, FormControl, InputLabel } from "@mui/material";

import { Excalidraw } from "@excalidraw/excalidraw";
import WangEditorComponent from './WangEditorComponent';

const ProblemCollectionComponent = ({ messages }) => {
    const { t } = useTranslation();


    const [loading, setLoading] = useState(false);
    const [loadingText,setLoadingText] = useState('loading');


    const showSnackbar = useSnackbar();
    const [colorManager, setColorManager] = useState(getColorDark());
    const [tabIndex, setTabIndex] = useState(0);
    const [searchInputValue,setSearchInputValue] = useState('');

    const [tableData, setTableData] = useState([]);
    const [pcClassList, setpcClassList] = useState([]);
    const [selectedPCId, setselectedPCId] = useState(null);
    const [currentPage, setCurrentPage] = useState(0);
    const [selectedRow,setSelectedRow] = useState({});

    const [pageCount, setPageCount] = useState(10); // 初始页数


    const [selectedClassId, setselectedClassId] = useState(null);
    const [platform, setPlatform] = useState("");

    const [capPlatform, setCapPlatform] = useState("");
    const [searchInputValueCapture,setSearchInputValueCapture] = useState('');


  //点击采集按钮时，显示采集界面，变量用于保存选中的分类id
    const [pcCollectionClassId,setPcCollectionClassId] = useState(0);




    const get_color_by_name = (name) => {

        const item = colorManager.find(item => item.container === name);
        return item.value;
      }

      

    const inputStyles = {
        paddingRight: '40px', // 为发送按钮留出空间
        color:get_color_by_name('mui-textfield-text-color'),
        fontFamily: 'siyuan',
      };

      useEffect(() => {
        
        loadDataList(1,20);
    }, []);  // 依赖数组




    const searchProblemCollection = async (pc_num,platform) => {
      try {
        setLoading(true);
        setLoadingText("loading");
        const dataToSend = {
          pcnum: pc_num,
          platform: platform,
        };
        const data = await requestUrl(dataToSend, "get_pc_detail_by_pt_num");
        
        if(data.status === "success"){
          setTableData(data.data);
         
          setselectedPCId(data.data[0].id);
          setTabIndex(1);

        }
      } catch (error) {
          console.error("获取数据时出错:", error);
      } finally {
        setLoading(false);
      }
    }


    const handleKeyDown  =async (e) => {
      
        if (e.key === 'Enter' && !e.shiftKey) {
          e.preventDefault();
          if(platform === ""){
            showSnackbar("选择平台","warning");
            return;
          }
          let pc_num = e.target.value;
          searchProblemCollection(pc_num,platform);
        }
        
      };




      const handleSearchInputChange = (event) => {
        setSearchInputValue(event.target.value);
    };



    const handleChangePage = async (event, newPage) => {
      
        setCurrentPage(newPage);
        //loadDataCommonChatSessionList(newPage);
        loadDataList(newPage,20)
      };

      const loadDataList = async (pagenum,pagesize) => {

        try {
          setLoading(true);
          setLoadingText("loading");
          const dataToSend = {
            page_number: pagenum,
            page_size: pagesize,
          };
          const data = await requestUrl(dataToSend, "get_pc_list_by_userid");
          
          if(data.status === "success"){
            setTableData(data.data);
            
            setpcClassList(data.classdata);  

          }
        } catch (error) {
            console.error("获取数据时出错:", error);
        } finally {
          setLoading(false);
          setShowAddPcClass(false);
        }

      }

      const handleClickRowProblemList = async (row) => {
  
        //setShowProblemAddEdit(true);
    
      }


      const handleClassClick = async (classid) => {
        
        try {
          setLoading(true);
          setLoadingText("loading");
          const dataToSend = {
            id:classid,
          };
          const data = await requestUrl(dataToSend, "get_pc_list_by_classid");
          
          if(data.status === "success"){
            setTableData(data.data);
          }
        } catch (error) {
            console.error("获取数据时出错:", error);
        } finally {
          setLoading(false);
        }
    };


    const [currentPcClassID,setCurrentPcClassID] = useState(0);
    const handleClickPCDetail = async (row) => {
      console.log(row.id);
      setCurrentPcClassID(row.pid);
      setTabIndex(1);
    }


    const handleChange = (event) => {
      setPlatform(event.target.value);
    };

    const handleButtonSearch = (event) => {
      if(platform === ""){
        showSnackbar("请选择平台","warning");
        return;
      }

      searchProblemCollection(searchInputValue,platform);
    };



    const [isShowCaptureUI,setIsShowCaptureUI] = useState(false);

    const handleCaptureProblem = async () => {
      setIsShowCaptureUI(true);
    };
    
    const handleCloseCaptureUI = async () => {
      setIsShowCaptureUI(false);
    };


    //点击采集按钮
    const handleBeginCapture = async () => {
      try {
        setLoading(true);

        setLoadingText("loading");

        console.log("pl:::" + capPlatform);
        console.log("vvv:::" + searchInputValueCapture);
        const dataToSend = {
          pcnum:searchInputValueCapture,
          platform:capPlatform,
          pid:pcCollectionClassId,
        };
        console.log("datasend:::" + JSON.stringify(dataToSend));
        const data = await requestUrl(dataToSend, "capture_pc_by_pnum_platform");
        
        if(data.status === "success"){
          setselectedPCId(data.data);
          setCurrentPcClassID(pcCollectionClassId);
          setTabIndex(1);

        }
      } catch (error) {
          console.error("获取数据时出错:", error);
      } finally {
        setLoading(false);
      }

    };
    
    const handleChangeCapturePNumber = (event) => {
      setCapPlatform(event.target.value);
    };

    
    const handleKeyDownCapture  =async (e) => {
      
      if (e.key === 'Enter' && !e.shiftKey) {
        e.preventDefault();
        if(capPlatform === ""){
          showSnackbar("选择平台","warning");
          return;
        }
        let pc_num = e.target.value;
        

        try {
          setLoading(true);
          setLoadingText("loading");
          const dataToSend = {
            pcnum:pc_num,
            platform:capPlatform,
          };
          const data = await requestUrl(dataToSend, "get_pc_list_by_classid");
          
          if(data.status === "success"){
            setTableData(data.data);
          }
        } catch (error) {
            console.error("获取数据时出错:", error);
        } finally {
          setLoading(false);
        }



      }
      
    };


    const handleSearchInputChangeCapture = (event) => {
      setSearchInputValueCapture(event.target.value);
  };



  const handleChangePCClassIdForCollection = (e) => {
    setPcCollectionClassId(e.target.value);
  };


  const [showAddPcClass,setShowAddPcClass] = useState(false);
const [addClassForPc,setAddClassForPc] = useState("");
  //tab页索引change
  const handleTabChange = (event, newValue) => {
    if(newValue === 2){//添加分
      setShowAddPcClass(true);
    }
    else{

       setTabIndex(newValue);
    }
  };

  const handleCloseAddClass = (e) => {
    setShowAddPcClass(false);
  };

  //新增分类事件
  const handleAddClassForPCBtn = async (e) => {
    
    try {
      setLoading(true);
      setLoadingText("loading");
      const dataToSend = {
        pcClassname:addClassForPc,
      };
      const data = await requestUrl(dataToSend, "add_pc_class_for_user");
      
      if(data.status === "success"){
        
        const newClass = { id: data.data, p_name: addClassForPc };
        setpcClassList(prevList => [...prevList, newClass]);
      }
    } catch (error) {
        console.error("获取数据时出错:", error);
    } finally {
      setLoading(false);
    }


  };
  
  const handleOnchangeAddPCClass = (e) => {
    setAddClassForPc(e.target.value);
  };

  const handleKeyDownForAddClassPC = (e) => {
    
  };

 
  
  const [openDialog, setOpenDialog] = useState(false);
  const [rowToDelete, setRowToDelete] = useState(null);

  const handleDeleteClickPC = async (row) => {
    setRowToDelete(row);  // Set the row to be deleted
    setOpenDialog(true);  // Open the confirmation dialog
  };

  const handleCloseDialog = () => {
    setOpenDialog(false);  // Close the dialog without deleting
  };

  const handleConfirmDelete = async () => {
    if (rowToDelete) {
      
      console.log(`Deleting row with ID: ${rowToDelete.id}`);
      try {
        setLoading(true);
        setLoadingText("loading");
        const dataToSend = {
          id:rowToDelete.id,
        };
        const data = await requestUrl(dataToSend, "delete_pc_problem_for_user");
        
        if(data.status === "success"){
          
          setTableData(prevList => prevList.filter(item => item.id !== rowToDelete.id));
        }
      } catch (error) {
          console.error("获取数据时出错:", error);
      } finally {
        setLoading(false);
      }

      
    }
    setOpenDialog(false);  // Close the dialog after deletion
  };

  const handleDisplayAllPcList = async () => {
    try {
      setLoading(true);
      setLoadingText("loading");
      const dataToSend = {
        id:0,
      };
      const data = await requestUrl(dataToSend, "get_all_pc_list_by_userid");
      
      if(data.status === "success"){
        
        setTableData(data.data);
      }
    } catch (error) {
        console.error("获取数据时出错:", error);
    } finally {
      setLoading(false);
    }
  };


  const [showCreateDoc,setShowCreateDoc] = useState(false);
  
  const handleCrateDcoument = () => {
    setShowCreateDoc(true);
  };


  const [selectedCreateDocClassId, setSelectedCreateDocClassId] = useState(null);
  
  const handleChangePCCLassNameForCreatedoc = (e) => {
    setSelectedCreateDocClassId(e.target.value);
  };
  const handleCloseCreateDoc = () => {
    setShowCreateDoc(false);
  };





 
  const [createDocName,setCreateDocName] = useState('');

//创建文档
  const handleCreateDocSendToServer = async () => {
    try {
      setLoading(true);
      setLoadingText("loading");
      const dataToSend = {
        title:createDocName,
        classid:selectedCreateDocClassId,
      };
      console.log("datais:");
      console.log(JSON.stringify(dataToSend));
      console.log("end::");
      const data = await requestUrl(dataToSend, "create_pc_doc_for_user");
      
      if(data.status === "success"){
        let pcid = data.data;
        setselectedPCId(pcid);
        showSnackbar(t('已创建'),'success');
        setCurrentPcClassID(selectedCreateDocClassId);
        setTabIndex(1);
        //setTableData(prevList => prevList.filter(item => item.id !== rowToDelete.id));
      }
    } catch (error) {
        console.error("获取数据时出错:", error);
    } finally {
      setLoading(false);
      setShowCreateDoc(false);
      
    }

  };


  

  const handleOnchangeCreateDocText = (e) => {
    setCreateDocName(e.target.value);

  }




  
    return (
        <Box sx={{ width: "100%", height: "90vh", display: "flex", flexDirection: "column" }}>
          <Box sx={{ display: "flex", justifyContent: "flex-end", background: "#f5f5f5" }}>
            <Tabs value={tabIndex} onChange={handleTabChange}>
              
              <Tab label="题目列表" />
              <Tab label="题目内容" />
              <Tab label="添加分类" />
            </Tabs>
          </Box>
          {tabIndex === 0 && (
            <Box sx={{ display: "flex", height: "calc(100% - 48px)"}} >
              <ResizableBox
                width={300}
                height={Infinity}
                axis="x"
                minConstraints={[150, Infinity]}
                maxConstraints={[400, Infinity]}
                resizeHandles={["e"]}
                sx={{ background: "#f5f5f5", padding: 2, display: "flex", flexDirection: "column", alignItems: "start" }}
              >
                <CustomButton onClick={handleCrateDcoument} sx={{ marginTop: "10px" }} width="95%">{t("新建文档")}</CustomButton>
                <CustomButton onClick={handleCaptureProblem} sx={{ marginTop: "10px" }} width="95%">{t("采集题目")}</CustomButton>

                <FormControl sx={{ width: "95%", marginTop: "10px", height: "35px" }}>
                  <Select
                    sx={{
                      color: "white",
                      height: "35px",
                      fontSize: "14px", // 适当缩小字体
                      "& .MuiOutlinedInput-root": {
                        height: "35px",
                        padding: "0px", // 移除额外填充
                      },
                      "& .MuiOutlinedInput-notchedOutline": {
                        borderColor: "white",
                      },
                      "&:hover .MuiOutlinedInput-notchedOutline": {
                        borderColor: "white",
                      },
                      "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
                        borderColor: "white",
                      },
                    }}
                    labelId="platform-select-label"
                    value={platform}
                    onChange={handleChange}
                  >
                    <MenuItem value="luogu">Luogu</MenuItem>
                    <MenuItem value="leetcode">LeetCode</MenuItem>
                  </Select>
                </FormControl>


                <TextField
                    onKeyDown={handleKeyDown}
                    value={searchInputValue}
                    onChange={handleSearchInputChange}
                    placeholder={t("problem number")}
                    
                    InputProps={{ sx: inputStyles }}
                    sx={{
                      width:"90%",
                      margin:"10px",
                      "& .MuiInputBase-root": {
                        backgroundColor: get_color_by_name("message-item-bg-all"),
                      },
                      "& .MuiOutlinedInput-root": {
                        "&:hover fieldset": {
                          borderColor: get_color_by_name("mui-textfield-bg"),
                        },
                        "&.Mui-focused fieldset": {
                          borderColor: "primary.main",
                        },
                        "& fieldset": {
                          borderColor: get_color_by_name("mui-textfield-bg"),
                        },
                      },
                    }}
                  />
                  
                  <CustomButton onClick={handleButtonSearch} width="95%">{t("search")}</CustomButton>
                  <CustomButton onClick={handleDisplayAllPcList} sx={{marginTop:"10px"}} width="95%">{t("display all")}</CustomButton>
                <List
                  sx={{
                    margin: "10px",
                    width: "calc(100% - 20px)",
                    bgcolor: get_color_by_name("pop-window-bg"),
                    borderRadius: "8px",
                    padding: "5px",
                  }}
                >
                  {pcClassList.map((row) => (
                    <ListItem
                      key={row.id}
                      button
                      onClick={() => handleClassClick(row.id)}
                      selected={selectedClassId === row.id}
                      sx={{
                        margin: "10px 0",
                        fontFamily: "siyuan",
                        fontWeight: 500,
                        color: "#ddd",
                        borderRadius: "6px",
                        transition: "all 0.3s ease",
                        textAlign: "center",
                        justifyContent: "center",
                        "&:hover": {
                          backgroundColor: "#444",
                        },
                        "&.Mui-selected": {
                          backgroundColor: "#555",
                          color: "#fff",
                          "&:hover": {
                            backgroundColor: "#666",
                          },
                        },
                      }}
                    >
                      <ListItemText primary={row.p_name} sx={{ textAlign: "center" }} />
                    </ListItem>
                  ))}
                </List>
              </ResizableBox>;

              <Box sx={{ flex: 1, border: "1px solid black" }}>
                
              <TableContainer component={Paper}>
                      <Table>
                        <TableHead>
                          <TableRow sx={{backgroundColor:get_color_by_name('pop-window-bg')}}>
                            <TableCell sx={{width:'50px', fontFamily:'siyuan',color:get_color_by_name('headline-color')}}>{t('number')}</TableCell>
                            <TableCell sx={{width:'100px', fontFamily:'siyuan',color:get_color_by_name('headline-color')}}>{t('problem number')}</TableCell>
                            <TableCell sx={{width:'100px', fontFamily:'siyuan',color:get_color_by_name('headline-color')}}>{t('problem from')}</TableCell>
                            <TableCell sx={{width:'400px', fontFamily:'siyuan',color:get_color_by_name('headline-color')}}>{t('problem tilte')}</TableCell>
                            <TableCell sx={{width:'350px', fontFamily:'siyuan',color:get_color_by_name('headline-color')}}>{t('tags')}</TableCell>
                            <TableCell sx={{width:'100px', fontFamily:'siyuan',color:get_color_by_name('headline-color')}}>{t('delete')}</TableCell>
                          </TableRow>
                        </TableHead>
                        <TableBody>
                        {tableData.filter(row => row.pid !== 0).map((row, index) => (
                            <TableRow key={row.id} selected={selectedPCId === row.id}
                              onClick={() => {
                                setselectedPCId(row.id);
                                setSelectedRow(row);
                              }}
                              hover
                              style={{ height:'20px', cursor: 'pointer', backgroundColor: selectedPCId === row.id ? get_color_by_name('mui-button-bg') : get_color_by_name('pop-window-bg') }}
                            >
                              <TableCell sx={{ fontFamily: 'siyuan', color: get_color_by_name('mui-textfield-text-color')}} onClick={() => handleClickRowProblemList(row)} >
                                {index + 1}
                              </TableCell>
                            
                              <TableCell
                                sx={{
                                  fontFamily: 'siyuan',
                                  color: get_color_by_name('mui-textfield-text-color'),
                                  textDecoration: 'underline', // 添加下划线
                                  cursor: 'pointer' // 鼠标悬停时显示为可点击
                                }}
                                onClick={() => handleClickPCDetail(row)}>
                              {row.p_number}
                            </TableCell>
                              <TableCell sx={{fontFamily:'siyuan',color:get_color_by_name('mui-textfield-text-color')}}>{row.p_from}</TableCell>
                              
                              <TableCell 
                                 sx={{
                                  fontFamily: 'siyuan',
                                  color: get_color_by_name('mui-textfield-text-color'),
                                  textDecoration: 'underline', // 添加下划线
                                  cursor: 'pointer' // 鼠标悬停时显示为可点击
                                }}
                                onClick={() => handleClickPCDetail(row)}
                              >
                                {row.p_name}</TableCell>
                              <TableCell sx={{fontFamily:'siyuan',color:get_color_by_name('mui-textfield-text-color')}}>{row.tags}</TableCell>
                              <TableCell sx={{fontFamily:'siyuan',color:get_color_by_name('mui-textfield-text-color')}}>
                                <IconButton 
                                  onClick={() => handleDeleteClickPC(row)} 
                                  sx={{color: get_color_by_name('mui-textfield-text-color')}}
                                >
                                  <DeleteIcon />
                                </IconButton>
                            </TableCell>
                            </TableRow>
                          ))}
                        </TableBody>
                      </Table>
                      
                    </TableContainer>
                    <Pagination
                      sx={{ backgroundColor:get_color_by_name('mui-textfield-bg') , borderRadius: '10px' ,marginTop:'10px'}}
                      count={pageCount}
                      page={currentPage}
                      onChange={handleChangePage}
                      color="primary"
                    />
              </Box>
            </Box>
          )}
          {tabIndex === 1 && <Box sx={{ height: "calc(100% - 48px)", background: "#fff" }}> {/* 空白内容 */} 
            <WangEditorComponent pcid={selectedPCId} pcClassList={pcClassList} currentPcClassID={currentPcClassID} platform={selectedRow.p_from} pnumber={selectedRow.p_number}/>
            </Box>
          }

      {showAddPcClass && (
        <Box
          sx={{
            position: 'fixed',
            top: '50%',
            left: '50%',
            transform: 'translate(-50%, -50%)',
            width: '40vw',
            height: '200px',
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'space-between',
            backgroundColor: get_color_by_name('pop-window-bg'),
            padding: 2,
            borderRadius: 2,
            boxShadow: 3,
            border: '1px solid white', // 添加黑色边框
          }}
        >

          <TextField
            onKeyDown={handleKeyDownForAddClassPC}
            value={addClassForPc}
            onChange={handleOnchangeAddPCClass}
            placeholder={t("填写分类名称")}
            InputProps={{ sx: inputStyles }}
            sx={{
              color: 'white',
              width: "100%",
              "& .MuiInputBase-root": {
                backgroundColor: get_color_by_name("message-item-bg-all"),
              },
              "& .MuiOutlinedInput-root": {
                "&:hover fieldset": {
                  borderColor: get_color_by_name("mui-textfield-bg"),
                },
                "&.Mui-focused fieldset": {
                  borderColor: "primary.main",
                },
                "& fieldset": {
                  borderColor: get_color_by_name("mui-textfield-bg"),
                },
              },
            }}
          />


          <Box sx={{ display: 'flex', justifyContent: 'flex-end', padding: '0 10px' }}>
            <CustomButton onClick={handleCloseAddClass} width="calc(50% - 5px)" sx={{ marginRight: '10px' }}>
              {t("关闭")}
            </CustomButton>
            <CustomButton onClick={handleAddClassForPCBtn} width="calc(50% - 5px)">
              {t("添加")}
            </CustomButton>
          </Box>
        </Box>
      )}


      {showCreateDoc && (
        <Box
          sx={{
            position: 'fixed',
            top: '50%',
            left: '50%',
            transform: 'translate(-50%, -50%)',
            width: '40vw',
            height: '200px',
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'space-between',
            backgroundColor: get_color_by_name('pop-window-bg'),
            padding: 2,
            borderRadius: 2,
            boxShadow: 3,
            border: '1px solid white', // 添加黑色边框
          }}
        >
          <TextField
            value={ createDocName}
            onChange={handleOnchangeCreateDocText}
            placeholder={t("文档标题")}
            InputProps={{ sx: inputStyles }}
            sx={{
              color: 'white',
              width: "100%",
              "& .MuiInputBase-root": {
                backgroundColor: get_color_by_name("message-item-bg-all"),
              },
              "& .MuiOutlinedInput-root": {
                "&:hover fieldset": {
                  borderColor: "white", // 鼠标悬停时边框颜色
                },
                "&.Mui-focused fieldset": {
                  borderColor: "white", // 聚焦时边框颜色
                },
                "& fieldset": {
                  borderColor: "white", // 默认边框颜色
                },
              },
            }}
          />

         <FormControl sx={{ width: "100%", marginTop: "10px", height: "35px" }}>
         <Select
             sx={{
              color: "white",
              height: "35px",
              fontSize: "14px", // 适当缩小字体
              "& .MuiOutlinedInput-root": {
                height: "35px",
                padding: "0px", // 移除额外填充
              },
              "& .MuiOutlinedInput-notchedOutline": {
                borderColor: "white",
              },
              "&:hover .MuiOutlinedInput-notchedOutline": {
                borderColor: "white",
              },
              "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
                borderColor: "white",
              },
            }}
            labelId="platform-select-label"
            value={selectedCreateDocClassId}
            onChange={handleChangePCCLassNameForCreatedoc}
          >
          {pcClassList.map((item) => (
                  <MenuItem key={item.id} value={item.id}>
                    {item.p_name}
                  </MenuItem>
                ))}
          </Select>
        </FormControl>

          <Box sx={{ display: 'flex', justifyContent: 'flex-end', padding: '0 10px' }}>
              <CustomButton onClick={handleCloseCreateDoc} width="calc(50% - 5px)" sx={{ marginRight: '10px' }}>
                {t("关闭")}
              </CustomButton>
              <CustomButton onClick={handleCreateDocSendToServer} width="calc(50% - 5px)">
                {t("添加")}
              </CustomButton>
          </Box>

        </Box>
      )}




      {isShowCaptureUI && (
        <Box
          sx={{
            position: 'fixed',
            top: '50%',
            left: '50%',
            transform: 'translate(-50%, -50%)',
            width: '40vw',
            height: '40vh',
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'space-between',
            backgroundColor: get_color_by_name('pop-window-bg'),
            padding: 2,
            borderRadius: 2,
            boxShadow: 3,
            border: '1px solid white', // 添加黑色边框
          }}
        >
       {/* Top Buttons */}
       
         <FormControl sx={{ width: "100%", marginTop: "10px", height: "35px" }}>
           <Select
             sx={{
               color: "white",
               height: "35px",
               fontSize: "14px", // 适当缩小字体
               "& .MuiOutlinedInput-root": {
                 height: "35px",
                 padding: "0px", // 移除额外填充
               },
               "& .MuiOutlinedInput-notchedOutline": {
                 borderColor: "white",
               },
               "&:hover .MuiOutlinedInput-notchedOutline": {
                 borderColor: "white",
               },
               "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
                 borderColor: "white",
               },
             }}
             labelId="platform-select-label"
             value={capPlatform}
             onChange={handleChangeCapturePNumber}
           >
             <MenuItem value="luogu">Luogu</MenuItem>
             <MenuItem value="leetcode">LeetCode</MenuItem>
           </Select>
         </FormControl>
     
         <TextField
           onKeyDown={handleKeyDownCapture}
           value={searchInputValueCapture}
           onChange={handleSearchInputChangeCapture}
           placeholder={t("problem number")}
           InputProps={{ sx: inputStyles }}
           sx={{
             color: 'white',
             width: "100%",
             margin: "10px",
             "& .MuiInputBase-root": {
               backgroundColor: get_color_by_name("message-item-bg-all"),
             },
             "& .MuiOutlinedInput-root": {
               "&:hover fieldset": {
                 borderColor: get_color_by_name("mui-textfield-bg"),
               },
               "&.Mui-focused fieldset": {
                 borderColor: "primary.main",
               },
               "& fieldset": {
                 borderColor: get_color_by_name("mui-textfield-bg"),
               },
             },
             "& .MuiOutlinedInput-notchedOutline": {
                borderColor: "white", // 默认边框颜色
              },
              "&:hover .MuiOutlinedInput-notchedOutline": {
                borderColor: "white", // 悬停时边框颜色
              },
              "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
                borderColor: "white", // 聚焦时边框颜色
              },
           }}
         />
     
     
       {/* Middle TextArea */}
       <FormControl sx={{ width: "100%", marginTop: "10px", height: "35px" }}>
       <Select
             sx={{
               color: "white",
               height: "35px",
               fontSize: "14px", // 适当缩小字体
               "& .MuiOutlinedInput-root": {
                 height: "35px",
                 padding: "0px", // 移除额外填充
               },
               "& .MuiOutlinedInput-notchedOutline": {
                 borderColor: "white",
               },
               "&:hover .MuiOutlinedInput-notchedOutline": {
                 borderColor: "white",
               },
               "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
                 borderColor: "white",
               },
             }}
            labelId="platform-select-label"
            value={pcCollectionClassId}
            onChange={handleChangePCClassIdForCollection}
    
  >
   {pcClassList.map((item) => (
          <MenuItem key={item.id} value={item.id}>
            {item.p_name}
          </MenuItem>
        ))}
  </Select>
      </FormControl>
     
       {/* Bottom Buttons */}
       <Box sx={{ display: 'flex', justifyContent: 'flex-end', padding: '0 10px' }}>
        <CustomButton onClick={handleCloseCaptureUI} width="calc(50% - 5px)" sx={{ marginRight: '10px' }}>
          {t("关闭")}
        </CustomButton>
        <CustomButton onClick={handleBeginCapture} width="calc(50% - 5px)">
          {t("采集")}
        </CustomButton>
      </Box>

        </Box>
     
      
      )}
        {loading && (
        <LoadingData text={t(loadingText)}/>
      )}

      {/* Confirmation Dialog */}
      <Dialog open={openDialog} onClose={handleCloseDialog}>
        <DialogTitle>删除确认</DialogTitle>
        <DialogContent>
          确认删除记录吗?
        </DialogContent>
        <DialogActions>
          <Button onClick={handleCloseDialog} color="primary">
            取消
          </Button>
          <Button onClick={handleConfirmDelete} color="secondary">
            删除
          </Button>
        </DialogActions>
      </Dialog>
    </Box>
    );
};
  

export default ProblemCollectionComponent;